import './CountdownOverlay.css';

export default function CountdownOverlay({ value }) {
  if (value == null) return null;
  return (
    <div className="countdown-overlay" aria-live="assertive">
      <div className="countdown-num">{value}</div>
      <div className="countdown-hint">นับถอยหลัง 2 วิ · เปิดไฟ · เตรียมถ่าย</div>
    </div>
  );
}
